import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import {
  ApiConnectionItemCreate,
  ApiConnectionItemDelete,
  ApiConnectionItemInitialState,
  ApiConnectionItemLoad,
  ApiConnectionItemUpdate,
} from './api-connection-item.actions';
import { ApiConnectionItemState, ApiConnectionItemStateModel } from './api-connection-item.state';
import { ApiConnectionModel } from '../models';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit';

@Injectable({ providedIn: 'root' })
export class ApiConnectionItemFacade implements LoadDataFacade, SetInitialStateFacade {
  state$: Observable<ApiConnectionItemStateModel> = this.store.select(ApiConnectionItemState.getState);
  apiConnectionData$: Observable<ApiConnectionModel> = this.store.select(ApiConnectionItemState.getApiConnection);
  apiConnectionId$: Observable<number> = this.store.select(ApiConnectionItemState.getApiConnectionId);
  apiConnectionName$: Observable<string> = this.store.select(ApiConnectionItemState.getApiConnectionName);
  loaded$: Observable<boolean> = this.store.select(ApiConnectionItemState.getLoaded);

  constructor(private store: Store) {}

  loadAll(apiConnectionId: string): void {
    this.store.dispatch(new ApiConnectionItemLoad(apiConnectionId));
  }

  createApiConnection(data: Partial<ApiConnectionModel>): void {
    this.store.dispatch(new ApiConnectionItemCreate(data));
  }

  updateApiConnection(data: Partial<ApiConnectionModel>): void {
    this.store.dispatch(new ApiConnectionItemUpdate(data));
  }

  deleteApiConnection(apiConnectionId: number, dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>): void {
    this.store.dispatch(new ApiConnectionItemDelete({ dialog, apiConnectionId }));
  }

  setInitialState(): void {
    this.store.dispatch(new ApiConnectionItemInitialState());
  }
}
